import { render, staticRenderFns } from "./HistoryDetails.vue?vue&type=template&id=49ce810f&scoped=true"
import script from "./HistoryDetails.vue?vue&type=script&lang=ts"
export * from "./HistoryDetails.vue?vue&type=script&lang=ts"
import style0 from "./HistoryDetails.vue?vue&type=style&index=0&id=49ce810f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ce810f",
  null
  
)

export default component.exports